// The cart builder's standalone AI Visibility section: the monthly AI
// Visibility product for any domain, hosted anywhere (squish-backend
// lib/av-standalone-catalog.js, productCode AI_VISIBILITY_STANDALONE).
//
// This side only cleans up what the rep typed and builds the line intent.
// squish-backend prices it (src/lib/cartQuote.js) and makes every call about
// it: whether the customer has the login it needs, whether the domain already
// has AI Visibility, and whether it is hosted with us (then the hosting add-on
// is the right product). Its refusal is shown to the rep as written.

export const AV_STANDALONE_CODE = 'AI_VISIBILITY_STANDALONE';
export const AV_STANDALONE_SKU = 'ai-visibility-standalone';

// Same shape the builder's domain check accepts.
const DOMAIN_RE = /^[a-z0-9-]+(\.[a-z0-9-]+)+$/;

// "https://www.Example.com/about" → "example.com". null when it is not a
// domain. The leading www. goes: it is the same site, and one AI Visibility
// product per domain is enforced on the name, so www.example.com and
// example.com must not read as two domains.
export function avDomain(input) {
  let d = String(input || '').trim().toLowerCase();
  d = d.replace(/^[a-z][a-z0-9+.-]*:\/\//, '');
  d = d.split(/[/?#]/)[0].replace(/:\d+$/, '').replace(/\.$/, '');
  d = d.replace(/^www\./, '');
  return DOMAIN_RE.test(d) ? d : null;
}

// One AI Visibility line per domain per cart.
export const avLineId = (domain) => `AV:${domain}`;

// The line intent squish-backend prices (POST /api/carts/quote).
export function avLine(domain) {
  return {
    productCode: AV_STANDALONE_CODE,
    productName: `AI Visibility — ${domain}`,
    quantity: 1,
    metadata: { domain, sku: AV_STANDALONE_SKU, billingTerm: 'monthly' },
  };
}

// Why the rep can't add it right now (null = addable). Works for an account
// or a prospect cart; squish-backend decides on the login at quote time.
//   input: what the rep typed
export function avBlocker({ isInvoice, input }) {
  if (isInvoice) return 'Card checkout only: switch to Card to sell AI Visibility';
  if (!String(input || '').trim()) return 'Enter the domain to watch (e.g. example.com)';
  if (!avDomain(input)) return 'Enter a full domain (e.g. example.com)';
  return null;
}
